import { SafeHTML } from "@/ui-components/SanitizeHTML";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, AlertProps, AlertTitle, Button, useTheme } from "@mui/material";
import { CustomContentProps, SnackbarContent } from "notistack";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

export type NotificationAlertSubtype = "Warning" | "Information" | "Error";

interface NotificationAlertProps extends CustomContentProps {
  closeNotification?: () => void;
  sub_type: NotificationAlertSubtype;
}

const notificationAlertSubTypeToSeverityMapping: Record<NotificationAlertSubtype, AlertProps["severity"]> = {
  Warning: "warning",
  Information: "info",
  Error: "error",
};

export const NotificationAlert = forwardRef<HTMLDivElement, NotificationAlertProps>(({ id, ...props }, ref) => {
  const { t } = useTranslation();
  const theme = useTheme();
  let color = "#B3E0E3";
  if (props.sub_type === "Warning") {
    color = "#FFE0A7";
  } else if (props.sub_type === "Error") {
    color = theme.palette.error.dark;
  }

  return (
    <SnackbarContent ref={ref}>
      <Alert
        severity={notificationAlertSubTypeToSeverityMapping[props.sub_type]}
        sx={{
          border: `1px solid ${color}`,
          boxShadow: "0px 6px 12px 0px #00000033",
        }}
        action={
          <Button color="inherit" size="small" onClick={props.closeNotification}>
            <CloseIcon />
          </Button>
        }
      >
        <AlertTitle
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            fontFamily: "Nunito Sans",
          }}
        >
          {t("general.Important_Notice")}
        </AlertTitle>
        {typeof props.message === "string" ? <SafeHTML html={props.message as string} /> : props.message}
      </Alert>
    </SnackbarContent>
  );
});
